import { createListenLogic, createRequestMachine, DOMAIN, MSG_HANDSHAKE_SYN, MSG_HANDSHAKE_SYN_ACK, MSG_HANDSHAKE_ACK, MSG_RESPONSE, MSG_HEARTBEAT, MSG_DISCONNECT } from "@sanity/comlink";
import { MSG_RESPONSE as MSG_RESPONSE2 } from "@sanity/comlink";
import { studioPath } from "@sanity/client/csm";
import { encodeSanityNodeData } from "./_chunks-es/transformSanityNodeData.js";
import { pathToUrlString, urlStringToPath } from "./_chunks-es/transformSanityNodeData.js";
const channelsToComlinkMap = {
  "handshake/syn": MSG_HANDSHAKE_SYN,
  "handshake/syn-ack": MSG_HANDSHAKE_SYN_ACK,
  "handshake/ack": MSG_HANDSHAKE_ACK,
  "channel/response": MSG_RESPONSE,
  "channel/heartbeat": MSG_HEARTBEAT,
  "channel/disconnect": MSG_DISCONNECT,
  "overlay/focus": "visual-editing/focus",
  "overlay/navigate": "visual-editing/navigate",
  "overlay/toggle": "visual-editing/toggle",
  "presentation/toggleOverlay": "presentation/toggle-overlay"
}, comlinkToChannelsMap = {
  [MSG_HANDSHAKE_SYN]: "handshake/syn",
  [MSG_HANDSHAKE_SYN_ACK]: "handshake/syn-ack",
  [MSG_HANDSHAKE_ACK]: "handshake/ack",
  [MSG_RESPONSE]: "channel/response",
  [MSG_HEARTBEAT]: "channel/heartbeat",
  [MSG_DISCONNECT]: "channel/disconnect",
  "visual-editing/focus": "overlay/focus",
  "visual-editing/navigate": "overlay/navigate",
  "visual-editing/toggle": "overlay/toggle",
  "presentation/toggle-overlay": "presentation/toggleOverlay"
}, convertToComlinkEvent = (event) => {
  const { data } = event;
  return data && typeof data == "object" && "domain" in data && "type" in data && "from" in data && "to" in data && (data.domain === "sanity/channels" && (data.domain = DOMAIN), data.to === "overlays" && (data.to = "visual-editing"), data.from === "overlays" && (data.from = "visual-editing"), data.channelId = data.connectionId, delete data.connectionId, data.type = channelsToComlinkMap[data.type] ?? data.type), event;
}, convertToChannelsMessage = (comlinkMessage) => {
  const { channelId, ...rest } = comlinkMessage, message = { ...rest, connectionId: channelId };
  return message.domain === DOMAIN && (message.domain = "sanity/channels"), message.to === "visual-editing" && (message.to = "overlays"), message.from === "visual-editing" && (message.from = "overlays"), message.type = comlinkToChannelsMap[message.type] ?? message.type, message.type === "channel/response" && message.responseTo && !message.data && (message.data = { responseTo: message.responseTo }), (message.type === "handshake/syn" || message.type === "handshake/syn-ack" || message.type === "handshake/ack") && (message.data = { id: message.connectionId }), message;
}, sendAsChannelsMessage = ({ context }, params) => {
  const { sources, targetOrigin } = context, message = convertToChannelsMessage(params.message);
  sources.forEach((source) => {
    source.postMessage(message, { targetOrigin });
  });
}, createCompatibilityActors = () => ({
  listen: createListenLogic(convertToComlinkEvent),
  requestMachine: createRequestMachine().provide({
    actions: {
      "send message": sendAsChannelsMessage
    }
  })
});
function createDataAttribute(props) {
  function normalizePath(path) {
    return path ? typeof path == "string" ? studioPath.fromString(path) : path : [];
  }
  function toString(props2) {
    if (!props2.id) throw new Error("`id` is required to create a data attribute");
    if (!props2.type) throw new Error("`type` is required to create a data attribute");
    if (!props2.path || !props2.path.length)
      throw new Error("`path` is required to create a data attribute");
    const attrs = {
      baseUrl: props2.baseUrl || "/",
      workspace: props2.workspace,
      tool: props2.tool,
      type: props2.type,
      id: props2.id,
      path: typeof props2.path == "string" ? props2.path : studioPath.toString(props2.path)
    };
    return encodeSanityNodeData(attrs);
  }
  const DataAttribute = (path) => toString({
    ...props,
    path: [...normalizePath(props.path), ...normalizePath(path)]
  });
  return DataAttribute.toString = function() {
    return toString(props);
  }, DataAttribute.combine = function(attrs) {
    return createDataAttribute({
      ...props,
      ...attrs
    });
  }, DataAttribute.scope = function(path) {
    return createDataAttribute({
      ...props,
      path: [...normalizePath(props.path), ...normalizePath(path)]
    });
  }, DataAttribute;
}
function getQueryCacheKey(query, params) {
  return `${query}-${typeof params == "string" ? params : JSON.stringify(params)}`;
}
const IS_MAC = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), MODIFIERS = {
  alt: "altKey",
  ctrl: "ctrlKey",
  mod: IS_MAC ? "metaKey" : "ctrlKey",
  shift: "shiftKey"
};
function isHotkey(keys, event) {
  return keys.every((key) => MODIFIERS[key] ? event[MODIFIERS[key]] : event.key === key.toUpperCase());
}
function isModKey(event) {
  return event.key === (IS_MAC ? "Meta" : "Ctrl");
}
function isAltKey(event) {
  return event.key === "Alt";
}
export {
  MSG_RESPONSE2 as MSG_RESPONSE,
  createCompatibilityActors,
  createDataAttribute,
  getQueryCacheKey,
  isAltKey,
  isHotkey,
  isModKey,
  pathToUrlString,
  urlStringToPath
};
//# sourceMappingURL=index.js.map
